/* LMGF Brands directory: search, category + toggles, URL state, A to Z, live counts, marquee pause. No dependencies.
   A brand can sit in several categories: each card's data-cat holds space-separated keys (e.g. "sweets drinks"). */
(function () {
  var root = document.querySelector('[data-lm-dir]');
  if (!root || root.__lm) return;
  root.__lm = 1;
  root.classList.add('js');

  var grid = root.querySelector('[data-dgrid]');
  var cards = [].slice.call(grid.querySelectorAll('.bc'));
  var join = root.querySelector('[data-join]');
  var empty = root.querySelector('[data-empty]');
  var q = root.querySelector('[data-dq]');
  var qx = root.querySelector('[data-dx]');
  var countEl = root.querySelector('[data-count]');
  var clears = [].slice.call(root.querySelectorAll('[data-clear]'));
  var chips = [].slice.call(root.querySelectorAll('.dchip[data-cat]'));
  var togs = [].slice.call(root.querySelectorAll('.dchip[data-tog]'));
  var tiles = [].slice.call(root.querySelectorAll('[data-tile]'));
  var az = [].slice.call(root.querySelectorAll('[data-az]'));
  var dir = root.querySelector('#dir');
  var bar = root.querySelector('.dbar');
  var TOTAL = cards.length;

  var fold = function (s) { return String(s || '').toLowerCase().normalize ? String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, "'").trim() : String(s || '').toLowerCase().trim(); };
  var data = cards.map(function (c) {
    var d = c.dataset;
    return { el: c, name: d.name, hay: fold(d.name + ' ' + d.tag + ' ' + d.catl), cats: String(d.cat || '').split(/\s+/).filter(Boolean), isnew: !!d.new, best: !!d.best, cert: !!d.cert, woman: !!d.woman, box: !!d.box,
      letter: fold(d.name).replace(/[^a-z0-9]/g, '').charAt(0).toUpperCase() };
  });
  /* A to Z by display name (server sorts by page title) */
  data.sort(function (a, b) { return fold(a.name).localeCompare(fold(b.name)); });
  data.forEach(function (x) { grid.insertBefore(x.el, join); });

  function inCat(x, k) {
    if (k === 'all') return true;
    if (k === 'new') return x.isnew;
    if (k === 'best') return x.best;
    return x.cats.indexOf(k) > -1;
  }

  var st = { q: '', cat: 'all', cert: false, woman: false, box: false };
  (function readUrl() {
    var p = new URLSearchParams(location.search);
    if (p.get('q')) st.q = p.get('q');
    var c = p.get('cat');
    if (c && chips.some(function (x) { return x.dataset.cat === c; })) st.cat = c;
    st.cert = p.get('cert') === '1'; st.woman = p.get('woman') === '1'; st.box = p.get('box') === '1';
    if (q) q.value = st.q;
  })();

  function matches(x, skipCat) {
    if (!skipCat && !inCat(x, st.cat)) return false;
    if (st.cert && !x.cert) return false;
    if (st.woman && !x.woman) return false;
    if (st.box && !x.box) return false;
    var f = fold(st.q);
    if (f && x.hay.indexOf(f) < 0) return false;
    return true;
  }
  function writeUrl() {
    var p = new URLSearchParams(location.search);
    ['q', 'cat', 'cert', 'woman', 'box'].forEach(function (k) { p.delete(k); });
    if (st.q.trim()) p.set('q', st.q.trim());
    if (st.cat !== 'all') p.set('cat', st.cat);
    if (st.cert) p.set('cert', '1');
    if (st.woman) p.set('woman', '1');
    if (st.box) p.set('box', '1');
    var s = p.toString();
    try { history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
  }
  function render() {
    var n = 0, firstOf = {};
    data.forEach(function (x) {
      var on = matches(x);
      x.el.hidden = !on;
      x.el.removeAttribute('id');
      if (on) { n++; if (x.letter && !firstOf[x.letter]) firstOf[x.letter] = x.el; }
    });
    Object.keys(firstOf).forEach(function (L) { firstOf[L].id = 'brand-' + L.toLowerCase(); });
    var any = st.cat !== 'all' || st.cert || st.woman || st.box || !!st.q.trim();
    countEl.textContent = n === TOTAL ? 'Showing all ' + n + ' brands' : 'Showing ' + n + ' of ' + TOTAL + ' brands';
    clears.forEach(function (b) { if (!b.closest('[data-empty]')) b.hidden = !any; });
    if (join) join.hidden = any;
    if (empty) empty.hidden = n !== 0;
    chips.forEach(function (c) {
      var k = c.dataset.cat, on = k === st.cat;
      c.classList.toggle('on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      var cnt = data.filter(function (x) { return inCat(x, k) && matches(x, true); }).length;
      var sm = c.querySelector('small'); if (sm) sm.textContent = cnt;
      if (c.classList.contains('dhi') && !st.q && !st.cert && !st.woman && !st.box) c.hidden = cnt === 0;
    });
    togs.forEach(function (t) {
      var on = !!st[t.dataset.tog];
      t.classList.toggle('on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false');
      var ic = t.querySelector('.ico'); if (ic) ic.hidden = !on;
    });
    tiles.forEach(function (t) { var on = t.dataset.tile === st.cat; t.classList.toggle('on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    az.forEach(function (b) {
      var has = !!firstOf[b.dataset.az];
      b.classList.toggle('off', !has); b.disabled = !has; b.tabIndex = has ? 0 : -1;
    });
    if (qx) qx.hidden = !st.q;
    writeUrl();
  }

  function offset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--lmgf-sticky-offset');
    return parseFloat(v) || 0;
  }
  function scrollToEl(el, extra) {
    if (!el) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = el.getBoundingClientRect().top + window.pageYOffset - offset() - (extra || 0);
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }

  var t;
  if (q) {
    q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { st.q = q.value; render(); }, 120); });
    q.addEventListener('keydown', function (e) { if (e.key === 'Escape') { q.value = ''; st.q = ''; render(); } });
  }
  if (qx) qx.addEventListener('click', function () { q.value = ''; st.q = ''; render(); q.focus(); });
  chips.forEach(function (c) { c.addEventListener('click', function () { var k = c.dataset.cat; st.cat = (st.cat === k && k !== 'all') ? 'all' : k; render(); }); });
  togs.forEach(function (g) { g.addEventListener('click', function () { var k = g.dataset.tog; st[k] = !st[k]; render(); }); });
  tiles.forEach(function (tl) {
    tl.addEventListener('click', function () {
      var k = tl.dataset.tile; st.cat = st.cat === k ? 'all' : k; render();
      scrollToEl(dir, 8);
    });
  });
  clears.forEach(function (b) { b.addEventListener('click', function () { st = { q: '', cat: 'all', cert: false, woman: false, box: false }; if (q) q.value = ''; render(); }); });
  az.forEach(function (b) {
    b.addEventListener('click', function () {
      var el = document.getElementById('brand-' + b.dataset.az.toLowerCase());
      scrollToEl(el, (bar ? bar.offsetHeight : 0) + 12);
    });
  });
  var go = root.querySelector('[data-godir]');
  if (go) go.addEventListener('click', function (e) { e.preventDefault(); scrollToEl(dir, 8); });

  /* marquee: pause when the tab is hidden */
  document.addEventListener('visibilitychange', function () { root.classList.toggle('paused', document.hidden); });

  render();
})();
